import {Component, Input, OnInit} from '@angular/core';
import {QueryParamsHandling} from "@angular/router";

@Component({
    selector: 'app-bread-crumb',
    templateUrl: './bread-crumb.component.html',
    styleUrls: ['./bread-crumb.component.scss'],
    standalone: false
})
export class BreadCrumbComponent implements OnInit {

  @Input() links: {
    name: string;
    route: string;
    id:number;
    queryParams: {};
    queryParamsHandling: QueryParamsHandling;
  }[] = [];

  constructor() {}

  ngOnInit() {
  }
  getQueryParams(index: number) {
    if (index === 3 && this.links[3]) {
      return { categories: this.links[3].id, inStock: true };
    }
    return { inStock: true };
  }
}
